import React, { useState, useEffect } from 'react';
import styles from './CustomerProfilePageData.module.scss';
import classNames from 'classnames/bind';
import DataCompleteness from './components/DataCompleteness/DataCompleteness';
import Phone from './components/Phone/Phone';
import Email from './components/Email/Email';
import Address from './components/Address/Address';
import { FieldType } from 'common/consts/fieldType';
import EditEmailPageData from 'templates/EditEmailPageData/EditEmailPageData';
import EditPhonePageData from 'templates/EditPhonePageData/EditPhonePageData';
import EditAddressPageData from 'templates/EditAddressPageData/EditAddressPageData';
import ContactDetailsUpdateConfirmationPageData from 'templates/ContactDetailsUpdateConfirmationPageData/ContactDetailsUpdateConfirmationPageData';
import EmailVerificationPageData from 'templates/EmailVerificationPageData/EmailVerificationPageData';
import MobileVerificationPageData from 'templates/MobileVerificationPageData/MobileVerificationPageData';
import PasswordEdit from './components/PasswordEdit/PasswordEdit';
import ResetPasswordPageData from 'templates/ResetPasswordPageData/ResetPasswordPageData';
import { useAppDispatch } from 'app/hooks';
import { refreshContent } from 'features/content/reducer';
import ResetAccount from './components/ResetAccount/ResetAccount';
import { logOutRedirectsToResetLogin } from 'features/core/reducer';
import { Market } from 'common/consts/markets';
import { useAppSelector } from 'app/hooks';
import { selectCurrentMarket } from 'features/core/selectors';
import { getGTMVariables, getGTMVariablesPageView } from 'common/helpers/Gtm';
import TagManager from 'react-gtm-module';
import { fetcher } from 'app/http';
import { useHistory } from 'react-router-dom';
interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
  EditEmailPageResponse?: any;
}

const CustomerProfilePageData = (props: Props) => {
  const dispatch = useAppDispatch();
  const { Model, PageData, LayoutModel, EditEmailPageResponse } = props;

  const [showPhone, setShowPhone] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [showAddress, setShowAddress] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showEmailConfirmation, setShowEmailConfirmation] = useState(false);
  const [showMobileVerification, setShowMobileVerification] = useState(false);
  const [showResetAccountPopup, setShowResetAccountPopup] = useState(false);

  const [setPhone, setEditPhoneResponse] = useState<any>({});
  const setEditPhoneResponseData = (param: any) => {
    setEditPhoneResponse(param);
  };

  const [setEmail, setEditEmailResponse] = useState<any>({});
  const setEditEmailResponseData = (param: any) => {
    console.log('param', param);
    setEditEmailResponse(param);
  };

  const [setAddress, setEditAddressResponse] = useState<any>({});
  const [setProfileConfirmation, setProfileConfirmationResponse] =
    useState<any>({});
  const [editAddressFormModel, setEditAddressFormModel] = useState<any>({});
  const [editAddressSubmitting, setEditAddressSubmitting] =
    useState<boolean>(false);
  const [editEmailSubmitting, setEditEmailSubmitting] =
    useState<boolean>(false);
  const [editPhoneSubmitting, setEditPhoneSubmitting] =
    useState<boolean>(false);
  const [setPassword, setEditPassword] = useState<any>({});

  const setEditAddressResponseData = (param: any) => {
    console.log('param', param);
    setEditAddressResponse(param);
    setEditAddressFormModel(param.Model.FormModel);
  };
  const setEditProfileConfirmationData = (param: any) => {
    console.log('param', param);
    setProfileConfirmationResponse(param);
  };
  const [setEmailConfirmation, setEditEmailConfirmationResponse] =
    useState<any>({});
  const setEditEmailConfirmationResponseData = (param: any) => {
    setEditEmailConfirmationResponse(param);
  };

  const [setMobileConfirmation, setEditMobileConfirmationResponse] =
    useState<any>({});
  const setEditMobileConfirmationResponseData = (param: any) => {
    setEditMobileConfirmationResponse(param);
  };
  const setEditPasswordResponseData = (param: any) => {
    console.log('param', param);
    setEditPassword(param.Model.FormModel);
  };

  const onDataSubmit = () => {
    // Refresh page content without reload on data change
    dispatch(refreshContent());
  };

  const handleLogOutRedirectsToLogin = async () => {
    try {
      setShowResetAccountPopup(false);
      detailsAccountTracking();
      dispatch(logOutRedirectsToResetLogin());
    } catch (err) {
      console.error(err);
    }
  };

  const onCancel = () => {
    setShowResetAccountPopup(false);
  };
  const currentMarket = useAppSelector(selectCurrentMarket);

  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid =
        LayoutModel?.Profiles.length > 0
          ? LayoutModel?.Profiles[0].DebtReference
          : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env,LayoutModel?.IsLoggedInUserSecured, LayoutModel?.SecuredCaseStatus);
      getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
    }
  }, [LayoutModel]);
  var tagManagerArgs: any;

  const detailsAccountTracking = () => {
    tagManagerArgs = {
      dataLayer: {
        event: 'reset_account',
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  };
  const handleEmailVerificationData = async () => {
    try {
      const response = await fetcher.get(Model.VerifyEmailPageUrl);
      if (response && response.data) {
        setEditEmailConfirmationResponseData(response.data);
        setShowEmailConfirmation(true);
      }
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    if (Model.emailOTPCode != null && Model.emailOTPCode != "") {
      handleEmailVerificationData();
    }
  }, [Model.emailOTPCode]);

  const history = useHistory();
  const getPathnameFromUrl = (url: string) => {
    const link = new URL(url);
    return link.pathname + link.search;
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.section}>
        <div className="Heading Heading--h3 Heading-h3--portal--large u-textCenter">
          {PageData?.ProfileHeader}
        </div>
        <DataCompleteness {...props} />

        <div className="cards">
          {(Model.PageDataBase?.IsPhoneHomeVisible ||
            Model.PageDataBase?.IsPhoneMobileVisible) &&
            (Model.ContactDetailsConfiguration.HomePhone !==
              FieldType.Unavailable ||
              Model.ContactDetailsConfiguration.MobilePhone !==
              FieldType.Unavailable) && (
              <Phone
                {...props}
                handleClick={setShowPhone}
                setEditPhoneResponseData={setEditPhoneResponseData}
              />
            )}
          {Model.PageDataBase?.IsEmailVisible &&
            Model.ContactDetailsConfiguration.Email !==
            FieldType.Unavailable && (
              <Email
                {...props}
                handleClick={setShowEmail}
                setEditEmailResponseData={setEditEmailResponseData}
              />
            )}
          <Address
            {...props}
            handleClick={setShowAddress}
            setEditAddressResponseData={setEditAddressResponseData}
          />
          <PasswordEdit
            {...props}
            handleClick={setShowPassword}
            setEditPasswordResponseData={setEditPasswordResponseData}
          />
        </div>
        <div className="singlecard">
          {(currentMarket === Market.FR ||
            currentMarket == Market.DE ||
            currentMarket === Market.ES ||
            currentMarket === Market.IT ||
            currentMarket === Market.PL) && (
              <ResetAccount {...props} handleClick={setShowResetAccountPopup} />
            )}
        </div>
        {showPhone && (
          <>
            <div className={'Overlay is-active ' + styles.overlayStyle}></div>
            <div
              className={classNames(
                styles.modaloverlay,
                showPhone ? 'Modal is-active Modal--float' : 'Modal',
              )}
            >
              <EditPhonePageData
                {...setPhone}
                handleClick={setShowPhone}
                handleClickMobileVerification={setShowMobileVerification}
                setEditPhoneConfirmationData={setEditProfileConfirmationData}
                //setEditPhoneResponseData={setEditPhoneResponseData}
                setEditMobileConfirmationResponseData={
                  setEditMobileConfirmationResponseData
                }
                setEditPhoneSubmitting={setEditPhoneSubmitting}
              />
              <div className="Modal-loader">
                <img
                  className="Modal-loaderIcon"
                  src="/assets/images/icons/loader/loader.gif"
                />
              </div>
            </div>
          </>
        )}
        {showEmail && (
          <>
            <div className={'Overlay is-active ' + styles.overlayStyle}></div>
            <div
              className={showEmail ? 'Modal is-active Modal--float' : 'Modal'}
            >
              <EditEmailPageData
                {...setEmail}
                handleClick={setShowEmail}
                handleClickEmailConfirmation={setShowEmailConfirmation}
                setEditEmailConfirmationResponseData={
                  setEditEmailConfirmationResponseData
                }
              />
              <div className="Modal-loader">
                <img
                  className="Modal-loaderIcon"
                  src="/assets/images/icons/loader/loader.gif"
                />
              </div>
            </div>
          </>
        )}
        {showAddress && (
          <>
            <div className={'Overlay is-active ' + styles.overlayStyle}></div>
            <div
              className={
                showAddress
                  ? 'Modal is-active Modal--float ' + styles.overlayEditAddress
                  : 'Modal'
              }
            >
              <EditAddressPageData
                editAddressFormModel={editAddressFormModel}
                setEditAddressFormModel={setEditAddressFormModel}
                setEditAddressSubmitting={setEditAddressSubmitting}
                setEditAddressConfirmationData={setEditProfileConfirmationData}
                setShowAddress={setShowAddress}
                onCancel={() => setShowAddress(false)}
                {...setAddress}
              />
              <div className="Modal-loader">
                <img
                  className="Modal-loaderIcon"
                  src="/assets/images/icons/loader/loader.gif"
                />
              </div>
            </div>
          </>
        )}
        {editAddressSubmitting && (
          <>
            <div className={'Overlay is-active ' + styles.overlayStyle}></div>
            <div
              className={
                editAddressSubmitting ? 'Modal is-active Modal--float' : 'Modal'
              }
            >
              <ContactDetailsUpdateConfirmationPageData
                onOk={() => {
                  onDataSubmit();
                  setEditAddressSubmitting(false);
                }}
                {...setProfileConfirmation}
              />
              <div className="Modal-loader">
                <img
                  className="Modal-loaderIcon"
                  src="/assets/images/icons/loader/loader.gif"
                />
              </div>
            </div>
          </>
        )}
        {showEmailConfirmation && (
          <>
            <div className={'Overlay is-active ' + styles.overlayStyle}></div>
            <div
              className={
                showEmailConfirmation ? 'Modal is-active Modal--float' : 'Modal'
              }
            >
              <EmailVerificationPageData
                handleClick={setShowEmail}
                handleClickEmailConfirmation={setShowEmailConfirmation}
                setEditEmailConfirmationResponseData={
                  setEditEmailConfirmationResponseData
                }
                setEditEmailSubmitting={setEditEmailSubmitting}
                setEditEmailConfirmationData={setEditProfileConfirmationData}
                {...setEmailConfirmation}
              />
              <div className="Modal-loader">
                <img
                  className="Modal-loaderIcon"
                  src="/assets/images/icons/loader/loader.gif"
                />
              </div>
            </div>
          </>
        )}
        {editEmailSubmitting && (
          <>
            <div className={'Overlay is-active ' + styles.overlayStyle}></div>
            <div
              className={
                editEmailSubmitting ? 'Modal is-active Modal--float' : 'Modal'
              }
            >
              <ContactDetailsUpdateConfirmationPageData
                onOk={() => {
                  var nextPagePath = getPathnameFromUrl(Model?.CustomerProfilePageUrl);
                  history.push(nextPagePath, {
                    noRefresh: false,
                  });
                  onDataSubmit();
                  setEditEmailSubmitting(false);
                  setShowEmailConfirmation(false);
                }}
                {...setProfileConfirmation}
              />
              <div className="Modal-loader">
                <img
                  className="Modal-loaderIcon"
                  src="/assets/images/icons/loader/loader.gif"
                />
              </div>
            </div>
          </>
        )}
        {showMobileVerification && (
          <>
            <div className={'Overlay is-active ' + styles.overlayStyle}></div>
            <div
              className={
                showMobileVerification
                  ? 'Modal is-active Modal--float'
                  : 'Modal'
              }
            >
              <MobileVerificationPageData
                handleClickMobileVerification={setShowMobileVerification}
                handleClick={setShowPhone}
                setEditMobileConfirmationResponseData={
                  setEditMobileConfirmationResponseData
                }
                setEditPhoneSubmitting={setEditPhoneSubmitting}
                setEditPhoneConfirmationData={setEditProfileConfirmationData}
                {...setMobileConfirmation}
              />
              <div className="Modal-loader">
                <img
                  className="Modal-loaderIcon"
                  src="/assets/images/icons/loader/loader.gif"
                />
              </div>
            </div>
          </>
        )}
        {editPhoneSubmitting && (
          <>
            <div className={'Overlay is-active ' + styles.overlayStyle}></div>
            <div
              className={
                editPhoneSubmitting ? 'Modal is-active Modal--float' : 'Modal'
              }
            >
              <ContactDetailsUpdateConfirmationPageData
                onOk={() => {
                  onDataSubmit();
                  setEditPhoneSubmitting(false);
                }}
                {...setProfileConfirmation}
              />
              <div className="Modal-loader">
                <img
                  className="Modal-loaderIcon"
                  src="/assets/images/icons/loader/loader.gif"
                />
              </div>
            </div>
          </>
        )}
        {showPassword && (
          <>
            <div className={'Overlay is-active ' + styles.overlayStyle}></div>
            <div className={'modal-overlay is-active'}>
              <div className={'modal-dialog reset-dialog'}>
                <div className="modal-content">
                  <ResetPasswordPageData
                    Model={Model.ResetPasswordModel}
                    PageData={PageData}
                    OnCancel={setShowPassword}
                    LayoutModel={LayoutModel}
                  />
                </div>
              </div>
            </div>
          </>
        )}
        {showResetAccountPopup && (
          <>
            <div
              className={
                'modal-overlay' && showResetAccountPopup
                  ? ' modal-overlay is-active'
                  : 'modal-overlay'
              }
            >
              <div className="modal-dialog">
                <div className="modal-content u-textCenter">
                  <a className="modal-close" onClick={() => onCancel()}></a>
                  <h3 className={styles.Heading}>
                    {PageData?.ResetLoginHeader}
                  </h3>
                  <p> {PageData?.ResetLoginDetails} </p>
                  <div className="u-marginTmd u-textCenter">
                    <button
                      onClick={() => handleLogOutRedirectsToLogin()}
                      className="Button u-block w-100 u-marginBxxsm"
                    >
                      {PageData?.ButtonLogoutAndResetLoginText}
                    </button>
                    <button
                      onClick={() => onCancel()}
                      className={classNames(
                        'Button w-100 Button--ghost gray-border u-block',
                        styles.grayborder,
                      )}
                    >
                      {PageData?.ButtonCancelText}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CustomerProfilePageData;
